module.exports = __webpack_public_path__ + "img/type-style4.d350bb17.png";